export enum TemplateDetailsStatusEnum {
   InCompleteDetails = 'InCompleteDetails',
   FetchedSystemFields = 'FetchedSystemFields',
   FetchedCompleteDetails = 'FetchedCompleteDetails'
}

export enum TaskTemplateTypeEnum {
   Call = 'CALL',
   Custom = 'CUSTOM',
   Default = 'DEFAULT'
}
